import * as _LocalStorage from './Platform/LocalStorage';
export { _LocalStorage as LocalStorage };